import { Component, Suspense } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

import { FullPageLoadingSpinner } from '@acre/design-system'

import AuthErrorPage from './AuthErrorPage'

type BoundaryState = { error: Error | null }

class AppErrorBoundary extends Component<{ children: ReactNode }, BoundaryState> {
  state: BoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): BoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    return <AuthErrorPage isDisabled={error.message?.includes('User is disabled')} />
  }
}

const AppSuspenseWrapper = ({ children }: { children: ReactNode }) => (
  <AppErrorBoundary>
    <Suspense fallback={<FullPageLoadingSpinner />}>{children}</Suspense>
  </AppErrorBoundary>
)

export default AppSuspenseWrapper
